import { render, staticRenderFns } from "./CreateRERCustomerMode.vue?vue&type=template&id=64f99ccd&scoped=true&"
import script from "./CreateRERCustomerMode.vue?vue&type=script&lang=ts&"
export * from "./CreateRERCustomerMode.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRERCustomerMode.vue?vue&type=style&index=0&id=64f99ccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f99ccd",
  null
  
)

export default component.exports